import React from "react";
import { Typography } from "@mui/material";

function QuestionInfoHeader({ currentQuestion, maximumMark, negativeMark,question }) {
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px 10px",
        borderBottom: "1px solid black",
      }}
    >
      <div>
        <Typography>Question No. {currentQuestion + 1}</Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Typography style={{ fontSize: "14px" }}>
          Maximum Mark:{" "}
          <span
            style={{
              padding: "2px 6px",
              color: "green",
              border: "1px solid green",
              borderRadius: "10px",
              backgroundColor: "#d0f0c0", // light green shade
              //   fontSize: "14px"
            }}
          >
            {maximumMark || "0.00"}
          </span>
        </Typography>
        <Typography style={{ fontSize: "14px" }}>
          Negative Mark:{" "}
          <span
            style={{
              padding: "2px 6px",
              color: "red",
              border: "1px solid red",
              borderRadius: "10px",
              backgroundColor: "#ffcdd2", // light red / pink shade
            }}
          >
            {negativeMark || "0.00"}
          </span>
        </Typography>
      </div>
    </div>
  );
}

export default QuestionInfoHeader;
